<script>
  import { format } from 'svelte-i18n';
  import { Badge, Button, Input, Label } from '@sveltestrap/sveltestrap';

  import { SectionItem } from '@client/components/section';
  import { ShowMore } from '@client/components/show-more';
  import { Spinner } from '@client/components/spinner';

  import { loadingConnections, syncConnections } from '@client/stores/sync-connections';

  export let deleting = false;
  export let emailbody = '';
  export let emailsubject = '';
  export let previousPush = undefined;
  export let pushing = false;
  export let signature = false;
  export let visual = false;
  export let onPush = () => {};

  $: hasFront = $syncConnections.checkfrontappconnected;
  $: hasGoogle = $syncConnections.checkgappsconnected;
  $: hasMicrosoft = $syncConnections.checko365connected;
  $: hasOutreach = $syncConnections.checkoutreachconnected;
  $: hasSalesforce = $syncConnections.checksalesforceconnected;
</script>

{#if $loadingConnections}
  <SectionItem fill>
    <Spinner show inline />
  </SectionItem>
{:else}
  {#if hasFront}
    <SectionItem label={$format('label.FRONTAPP')} description={$format('label.PUSH_TO_FRONTAPP')} data-testid="front">
      <span slot="label">
        {#if previousPush === 'pushfrontapp'}
          <Badge class="ms-2" tag="small">{$format('label.PUSHER_PREVIOUS_PUSH')}</Badge>
        {/if}
      </span>
      <div class="text-right">
        <Button color="primary" disabled={pushing} on:click={() => onPush('front')}>{$format('label.PUSH')}</Button>
      </div>
    </SectionItem>
  {/if}
  {#if hasGoogle}
    <SectionItem
      label={$format('label.GOOGLE')}
      description={$format('label.PUSH_TO_GOOGLE_WORKSPACE')}
      data-testid="google"
    >
      <span slot="label">
        {#if previousPush === 'pushgoogle'}
          <Badge class="ms-2" tag="small">{$format('label.PUSHER_PREVIOUS_PUSH')}</Badge>
        {/if}
      </span>
      <div class="text-right">
        <Button color="primary" disabled={pushing} on:click={() => onPush('google')}>{$format('label.PUSH')}</Button>
      </div>
    </SectionItem>
  {/if}
  {#if hasMicrosoft}
    <SectionItem
      label={$format('label.MICROSOFT')}
      description={$format('label.PUSH_TO_MICROSOFT_365')}
      data-testid="o365"
    >
      <span slot="label">
        {#if previousPush === 'pusho365'}
          <Badge class="ms-2" tag="small">{$format('label.PUSHER_PREVIOUS_PUSH')}</Badge>
        {/if}
      </span>
      <div class="text-right">
        <Button color="primary" disabled={pushing} on:click={() => onPush('o365')}>{$format('label.PUSH')}</Button>
      </div>
    </SectionItem>
  {/if}
  {#if hasOutreach}
    <SectionItem
      label={$format('label.OUTREACH')}
      description={$format('label.PUSH_TO_OUTREACH')}
      data-testid="outreach"
    >
      <span slot="label">
        {#if previousPush === 'pushoutreach'}
          <Badge class="ms-2" tag="small">{$format('label.PUSHER_PREVIOUS_PUSH')}</Badge>
        {/if}
      </span>
      <div class="text-right">
        <Button color="primary" disabled={pushing} on:click={() => onPush('outreach')}>{$format('label.PUSH')}</Button>
      </div>
    </SectionItem>
  {/if}
  {#if signature && !visual && hasSalesforce}
    <SectionItem
      label={$format('label.SALESFORCE')}
      description={$format('label.PUSH_TO_SALESFORCE')}
      data-testid="salesforce"
    >
      <span slot="label">
        {#if previousPush === 'pushsalesforce'}
          <Badge class="ms-2" tag="small">{$format('label.PUSHER_PREVIOUS_PUSH')}</Badge>
        {/if}
      </span>
      <div class="text-right">
        <Button color="primary" disabled={pushing} on:click={() => onPush('salesforce')}>{$format('label.PUSH')}</Button
        >
      </div>
    </SectionItem>
  {/if}
{/if}
{#if signature && !deleting}
  <SectionItem label={$format('label.EMAIL_SIGNATURE_REMINDER')} data-testid="email">
    <span slot="label">
      {#if previousPush === 'pushemail'}
        <Badge class="ms-2" tag="small">{$format('label.PUSHER_PREVIOUS_PUSH')}</Badge>
      {/if}
    </span>
    <span slot="description">
      {$format('label.DESCRIPTION.EMAIL_SIGNATURE_REMINDER')}
      <div data-testid="email-customize">
        <ShowMore
          expanded={!!(emailsubject || emailbody)}
          collapsedText="label.PUSHER_CUSTOMIZE_EMAIL"
          expandedText="label.HIDE"
        >
          <Label for="pusher-email-subject" class="mt-2">{$format('label.SUBJECT')}</Label>
          <Input id="pusher-email-subject" data-testid="email-subject-input" type="text" bind:value={emailsubject} />
          <Label for="pusher-email-body" class="mt-2">{$format('label.BODY')}</Label>
          <Input
            class="mb-2"
            id="pusher-email-body"
            data-testid="email-body-input"
            type="textarea"
            rows={3}
            bind:value={emailbody}
          />
        </ShowMore>
      </div>
    </span>
    <div class="text-right">
      <Button color="primary" disabled={pushing} on:click={() => onPush('email')}>{$format('label.SEND')}</Button>
    </div>
  </SectionItem>
{/if}
